<template>
    <div
        class="col-12 col-lg-8 algolia-listing-product-block__product-options-wrapper"
    >
        <div class="row" v-for="(combination, combinationIndex) in combinations">
            <form
                class="col-12 mb-0"
                :name="`buy_${combination.id_product_attribute}`"
                :action="linkToCart"
            >
                <div
                    class="row"
                    itemprop="offers"
                    itemscope
                    itemtype="https://schema.org/Offer"
                >
                    <div
                        class="col-9 algolia-listing-product-block__product-option-item-wrapper"
                    >
                        <div
                            class="algolia-listing-product-block__product-option-item"
                            :class="{
                                'algolia-listing-product-block__product-option-item--unavailable': hasUnavailableStatus(
                                    combination
                                )
                            }"
                        >
                            <div class="row">
                                <div
                                    class="algolia-listing-product-block__product-amount-wrapper"
                                    :class="newPricingFeatureEnabled ? 'col-5' : 'col-4'"
                                >
                                    <div>
                                        <div
                                            class="algolia-listing-product-block__product-amount"
                                        >
                                            <span :title="combination.attribute_name">{{ truncate(combination.attribute_name , 24) }}</span>
                                        </div>
                                        <product-combination-promotion-text
                                            v-if="combination.attribute_promotion_name"
                                            :name="combination.attribute_promotion_name"
                                        />
                                        <div
                                            v-if="combination.mqc"
                                            class="mqc_product_notification mqc_single_product_notification"
                                        >
                                            {{ $t("algoliaSearch.mqc.max") }} {{ combination.mqc }} {{ $t("algoliaSearch.mqc.perCustomer") }}
                                        </div>
                                    </div>

                                    <div
                                        v-if="truncate(combination.attribute_name, 24) !== combination.attribute_name"
                                        class="algolia-listing-product-block__mobile-tooltip-button algolia-listing-product-block__mobile-tooltip-button--pdp cursor-pointer"
                                        @click="toggleTooltip($event, true, combinationIndex)"
                                    >
                                        <i class="fal fa-info-circle"></i>
                                    </div>

                                    <div
                                        v-if="tooltipIsOpen[combinationIndex]"
                                        @click.self="preventClosingTooltip"
                                        class="algolia-listing-product-block__mobile-tooltip algolia-listing-product-block__mobile-tooltip--pdp"
                                    >
                                        <div class="d-flex justify-content-between mb-1">
                                            <span class="mt-1" v-text="combination.attribute_name"></span>
                                            <div class="algolia-listing-product-block__mobile-tooltip-close-button" @click="toggleTooltip($event, false, combinationIndex)">
                                                <i class="fas fa-times-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-8" v-if="! newPricingFeatureEnabled">
                                    <APricingReduction
                                        v-if="
                                            combination.price_reduction &&
                                                combination.available_now
                                        "
                                        :combination="combination"
                                    />
                                    <APricingNormal
                                        v-else-if="
                                            combination.available_now &&
                                                !hasUnavailableStatus(
                                                    combination
                                                ) &&
                                                !combination.bundle_discount_formatted
                                        "
                                        :combination="combination"
                                        :promotion="combination.attribute_promotion_name"
                                    />
                                    <APricingDiscount
                                        v-else-if="combination.available_now && !hasUnavailableStatus(combination) && combination.bundle_discount_formatted"
                                        :combination="combination"
                                    />
                                    <APricingNotAvailable
                                        v-else
                                        :lang-iso="langIso"
                                        :combination="combination"
                                    />
                                </div>
                                <div class="col-7" v-if="newPricingFeatureEnabled">
                                    <BPricingReduction
                                        v-if="
                                            combination.price_reduction &&
                                                combination.available_now
                                        "
                                        :combination="combination"
                                    />
                                    <BPricingNormal
                                        v-else-if="
                                            combination.available_now &&
                                                !hasUnavailableStatus(
                                                    combination
                                                ) &&
                                                !combination.bundle_discount_formatted
                                        "
                                        :combination="combination"
                                        :promotion="combination.attribute_promotion_name"
                                    />
                                    <BPricingDiscount
                                        v-else-if="combination.available_now && !hasUnavailableStatus(combination) && combination.bundle_discount_formatted"
                                        :combination="combination"
                                    />
                                    <BPricingNotAvailable
                                        v-else
                                        :lang-iso="langIso"
                                        :combination="combination"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-1 px-0 d-flex algin-items-center">
                        <div v-if="combination.available_now" class="d-flex">
                            <input
                                type="hidden"
                                name="id_product"
                                :value="idProduct"
                            />
                            <input
                                type="hidden"
                                name="id_product_attribute"
                                :value="combination.id_product_attribute"
                            />
                            <input
                                type="hidden"
                                name="minimal_quantity"
                                value="1"
                            />
                            <input type="hidden" name="add" value="1" />

                            <AmountInput
                                :id-product="idProduct"
                                :id-product-attribute="
                                    combination.id_product_attribute
                                "
                            />
                        </div>
                    </div>

                    <div
                        v-if="!hasUnavailableStatus(combination)"
                        class="col-2 d-flex align-items-center"
                    >
                        <button
                            class="algolia-listing-product-block__buy-button product-list__item__add-to-cart-button"
                            :data-id-product="idProduct"
                            :data-query-id="queryId"
                            :data-position="position"
                            :data-object-id="objectId"
                            :data-id-product-attribute="
                                combination.id_product_attribute
                            "
                            @click="$emit('buy')"
                            data-minimal_quantity="1"
                            data-dismiss="modal"
                        >
                            <i class="fa fa-shopping-cart"></i>
                        </button>
                    </div>

                    <div v-else class="col-2 d-flex align-items-center">
                        <button
                            @click.prevent="handleOutOfStock($event, combination)"
                            class="algolia-listing-product-block__buy-button algolia-listing-product-block__buy-button--unavailable"
                        >
                            <i class="fa fa-envelope"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import APricingReduction  from "./Pricing/A/PricingReduction";
import APricingNormal  from "./Pricing/A/PricingNormal";
import APricingNotAvailable  from "./Pricing/A/PricingNotAvailable";
import APricingDiscount from "./Pricing/A/PricingDiscount.vue";
import BPricingReduction from "./Pricing/B/PricingReduction";
import BPricingNormal from "./Pricing/B/PricingNormal";
import BPricingNotAvailable from "./Pricing/B/PricingNotAvailable";
import BPricingDiscount from "./Pricing/B/PricingDiscount.vue";
import AmountInput from "./Inputs/AmountInput";
import ProductCombinationPromotionText from "./ProductCombinationPromotionText.vue";
import { triggerBackInStockNotificationAnimation } from "../../js/animated-buttons";
import ProductCombinationMqcText from "./ProductCombinationMqcText.vue";
import { isFeatureEnabled } from "../../js/helper/ab-test-helper";

export default {
    components: {
        ProductCombinationMqcText,
        APricingReduction,
        ProductCombinationPromotionText,
        AmountInput,
        APricingNormal,
        APricingNotAvailable,
        APricingDiscount,
        BPricingReduction,
        BPricingNormal,
        BPricingNotAvailable,
        BPricingDiscount,
    },
    props: {
        combinations: {
            type: Array,
            required: true
        },
        idProduct: {
            type: Number,
            required: true
        },
        queryId: {
            type: [String, Number],
            required: true
        },
        objectId: {
            type: String,
            required: true,
        },
        position: {
            type: [String, Number],
            required: true
        },
        linkToCart: {
            type: String,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
    },
    data() {
        return {
            tooltipIsOpen: [],
            newPricingFeatureEnabled: true,
        }
    },
    methods: {
        formattedAvailableDate: availableDate => {
            // ToDO: Send the correct formatter.
            return new Date(availableDate);
        },
        handleOutOfStock(event, combination) {
            let stockButton = event.target;

            if (stockButton.type !== 'button') {
                // Target is the icon, search for the button

                stockButton = stockButton.closest('button');
            }

            triggerBackInStockNotificationAnimation(stockButton);

            this.$emit("out-of-stock");
            $("#out-of-stock-opt-in-modal").removeClass("d-none");
            $("#out-of-stock-optin-attribute").val(combination.id_product_attribute);
        },
        hasUnavailableStatus(combination) {
            return (
                !combination.available_now ||
                combination.unavailable_status_text
            );
        },
        truncate(data,num){
            if  (! data) {
                return '';
            }

            let truncatedString = data.split("").slice(0, num).join("");

            if (truncatedString !== data) {
                truncatedString += '...';
            }

            return truncatedString;
        },
        toggleTooltip(event, preventPropagation, index) {
            if (preventPropagation) {
                this.preventClosingTooltip(event);
            }

            if (typeof this.tooltipIsOpen[index] === 'undefined') {
                this.tooltipIsOpen[index] = true;

                return;
            }

            this.tooltipIsOpen[index] = !this.tooltipIsOpen[index];
        },
        preventClosingTooltip(event) {
            event.stopPropagation();
        }
    },
    mounted() {
        document.addEventListener('click', () => {
            this.tooltipIsOpen.forEach((tooltip, tooltipKey) => this.tooltipIsOpen[tooltipKey] = false);
        });
    }
};
</script>
